// The visitor's ad data consent (HubSpot contact property ttd_ad_data_consent),
// sent with the booking as ad_measurement_consent: true / false, or left out
// when unknown.
//
// - UK booking subdomain (.co.uk): HubSpot's cookie banner decides, read via
//   its consent listener. Until the listener reports, a ttd_adc=1/0 added to
//   the booking link by the main site is used.
// - Anywhere else (tapestodigital.biz while it runs): only ttd_adc from the URL.
// - AU bookings get no value — the backend drops it for AU locations, since
//   the booked location (not the domain) decides the country.
//
// Kept in sessionStorage so the value survives the multi-step flow and the
// customer changing their banner choice mid-booking updates it.

const URL_KEY = "t2d_adc_url";
const LISTENER_KEY = "t2d_adc_listener";

// Fallback when storage is blocked (private mode): this page view only
const memory = {};

function readBool(key) {
  try {
    const value = sessionStorage.getItem(key);
    return value === "true" ? true : value === "false" ? false : null;
  } catch (e) {
    return memory[key] ?? null;
  }
}

function writeBool(key, value) {
  memory[key] = value;
  try {
    sessionStorage.setItem(key, String(value));
  } catch (e) {
    // memory copy above is enough for this page view
  }
}

export const isUkBookingDomain = (hostname = window.location.hostname) =>
  hostname.slice(-6) === ".co.uk";

// Call once on app start with the landing URL's query string.
export function initAdConsent({ search = "", hostname = window.location.hostname } = {}) {
  // A newer booking link carrying ttd_adc replaces an older one's value
  const adc = new URLSearchParams(search).get("ttd_adc");
  if (adc === "1" || adc === "0") writeBool(URL_KEY, adc === "1");

  if (isUkBookingDomain(hostname)) {
    // HubSpot calls this on load once the banner state is known, and again
    // whenever the visitor changes their choice.
    const _hsp = (window._hsp = window._hsp || []);
    _hsp.push([
      "addPrivacyConsentListener",
      function (consent) {
        const adConsent = !!(consent && consent.categories && consent.categories.advertisement);
        writeBool(LISTENER_KEY, adConsent);
      },
    ]);
  }
}

// true / false, or null when unknown (never sent as empty)
export function getAdConsent() {
  const fromListener = isUkBookingDomain() ? readBool(LISTENER_KEY) : null;
  return fromListener !== null ? fromListener : readBool(URL_KEY);
}
